import { CSSProperties } from 'react';

import { bodyWidth } from 'constants/values';

export const container: CSSProperties = {
  backgroundColor: '#FFC52E',
  width: '100%',
};

export const body: CSSProperties = {
  backgroundColor: '#FFC52E',
  height: 941,
  margin: 'auto',
  position: 'relative',
  width: bodyWidth,
};

export const image1: CSSProperties = {
  height: 245,
  left: 528,
  position: 'absolute',
  top: 83,
  width: 425,
};

export const image2: CSSProperties = {
  height: 270,
  left: 280,
  position: 'absolute',
  top: 328,
  width: 880,
};
